<template>
  <div class="box-edit d-flex" :class="{ loading: loadingRemove }">
    <div v-if="loadingRemove" class="loading-remove">
      <b-spinner variant="secondary" />
    </div>

    <div class="integration">
      <img v-if="image" :src="image" class="image-icon" />
      <div class="d-flex align-items-center text-neutral-700 text-left">
        {{ title }}
      </div>
    </div>

    <div class="buttons">
      <bp-button
        icon="fa-solid fa-pen"
        label="Editar"
        color="neutral"
        variant="outlined-1"
        block
        size="sm"
        @click="$emit('edit')"
      />
      <bp-button
        icon="fa-light fa-x"
        label="Remover"
        color="negative"
        variant="outlined-1"
        block
        size="sm"
        @click="showingRemoveDialog = true"
      />
    </div>

    <confirmation
      v-model="showingRemoveDialog"
      iconType="warning"
      title="Tem certeza que deseja remover?"
      cancelButtonText="Cancelar"
      confirmButtonClass="btn-danger"
      confirmButtonText="Remover"
      @confirm="$emit('remove')"
      @cancel="showingRemoveDialog = false"
    />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    image: {
      type: String,
      default: null
    },
    showRemoveButton: {
      type: Boolean,
      default: false
    },
    loadingRemove: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showingRemoveDialog: false
    };
  }
};
</script>

<style lang="scss" scoped>
.box-edit {
  padding: 16px;
  border-radius: 4px;
  border: 1px solid #d2d0d8;
  display: flex;
  flex-direction: column;
  gap: 24px;

  .integration {
    display: grid;
    grid-template-columns: 1fr 3fr;
    gap: 12px;
    width: 100%;
  }

  .image-icon {
    width: 100%;
    height: auto;
    border-radius: 10px;
  }

  .buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }

  .loading-remove {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.05);
  }

  &.loading {
    opacity: 0.5;
  }
}
</style>
